import Splide from "@splidejs/splide";

export const shopModalSliders = () => {
  if (document.querySelector(".js-shop-modal-main-slider") === null) {
    return;
  }

  const sliderGroups = document.querySelectorAll(".js-shop-modal-slider-group");

  sliderGroups.forEach((sliderGroup) => {
    const mainSlider = sliderGroup.querySelector(".js-shop-modal-main-slider");
    const thumbSlider = sliderGroup.querySelector(".js-shop-modal-thumb-slider");
    const progressBar = sliderGroup.querySelector(".js-shop-modal-thumb-slider-progress-bar");

    const main = new Splide(mainSlider, {
      type: "fade",
      speed: 1000,
      rewind: true,
      pagination: false,
      arrows: false,
      lazyLoad: "nearby",
    });

    const thumb = new Splide(thumbSlider, {
      height: "100%",
      gap: "0.5rem",
      perPage: 5,
      perMove: 5,
      speed: 1000,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: {
        768: {},
      },
    });

    const updateProgressBar = () => {
      if (!progressBar) return;
      const currentIndex = thumb.index;
      const totalSlides = thumb.Components.Slides.getLength();
      const progress = ((currentIndex + 1) / totalSlides) * 100;
      progressBar.style.width = `${progress}%`;
    };

    if (progressBar) {
      thumb.on("move", updateProgressBar);
      thumb.on("mounted", updateProgressBar);
    }

    main.sync(thumb);

    main.mount();
    thumb.mount();
  });
};
